// Keep this small login contract identical across independently built apps.
export function takeSsoHandoff(location = window.location, history = window.history) {
  const url = new URL(location.href);
  const rawHash = url.hash.slice(1);
  const match = rawHash.match(/(?:^|[?&])(?:sso|sso_token)=([^&]*)/);
  let token = null;
  if (match) {
    try { token = decodeURIComponent(match[1]); } catch (_) { token = 'invalid'; }
  }
  token = token || url.searchParams.get('sso_token') || url.searchParams.get('sso');
  if (!token) return null;
  url.searchParams.delete('sso_token');
  url.searchParams.delete('sso');
  url.hash = rawHash.replace(/(^|[?&])(?:sso|sso_token)=[^&]*/g, (_, prefix) => prefix === '?' ? '?' : '').replace(/\?&/g, '?').replace(/^&/, '').replace(/[?&]$/, '');
  history.replaceState(null, '', url.pathname + url.search + url.hash);
  return token;
}

export async function exchangeSsoHandoff(token, endpoint, fetchImpl = window.fetch.bind(window)) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetchImpl(endpoint, {
      method: 'POST', credentials: 'include', signal: controller.signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sso_token: token }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.success !== true) {
      throw new Error(data.message || '통합 로그인 연결에 실패했습니다. 앤츠톡에서 다시 열어주세요.');
    }
    // Never let an old cached identity/token override the newly verified cookie.
    for (const storage of [window.sessionStorage, window.localStorage]) {
      for (const key of ['user', 'auth_token', 'sso_token', 'sso_checked']) storage.removeItem(key);
    }
  } finally { clearTimeout(timer); }
}

export function startLinkedApp(render, endpoint, onVerified = () => {}) {
  const token = takeSsoHandoff();
  if (!token) { render(); return Promise.resolve(); }
  const root = document.getElementById('root');
  const attempt = async () => {
    root.textContent = '통합 로그인 확인 중…';
    try {
      await exchangeSsoHandoff(token, endpoint);
      onVerified(token);
      root.textContent = '';
      render();
    } catch (error) {
      // Do not mount the app (and restore another account) after a failed handoff.
      root.textContent = error.name === 'AbortError' ? '로그인 연결이 지연되고 있습니다.' : error.message;
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = '다시 시도';
      retry.addEventListener('click', attempt);
      root.appendChild(retry);
    }
  };
  return attempt();
}
